"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserStudyPlan = exports.UserStudyPlanProvider = void 0;
var react_1 = __importDefault(require("react"));
var helpers_1 = require("../../helpers");
var useStudyPlan_1 = require("../../hooks/useStudyPlan");
var UserProvider_1 = require("../UserProvider");
var _a = __read(helpers_1.createContext(), 2), hook = _a[0], Provider = _a[1];
exports.UserStudyPlanProvider = function (_a) {
    var children = _a.children;
    var user = UserProvider_1.useUser();
    var studyPlan = useStudyPlan_1.useStudyPlan(user.id);
    function toggleItemDone(item) {
        studyPlan.toggleItemDone(item);
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (!item.done && !item.donePreviously) {
            user.incrementStatistic('items-completed');
        }
    }
    return (react_1.default.createElement(Provider, { value: __assign(__assign({}, studyPlan), { toggleItemDone: toggleItemDone }) }, children));
};
exports.useUserStudyPlan = hook;
//# sourceMappingURL=UserStudyPlanProvider.js.map